import { Rating } from "@mui/material";
import { useHistory } from "react-router-dom";
import { Aa } from "../functions/Aa";
import "../styles/discover-our-chef.css";

const ChefCard = ({ chef, selectedWhen, setChef }) => {
  const history = useHistory();

  return (
    <div
      onClick={() => {
        setChef(chef);
        history.push(`/order/chef/menu?chef=${chef?._id}&date=${selectedWhen}`);
      }}
    >
      <div className="section-chef-card">
        <div className="chef-card">
          <div className="chef-item">
            <span className="chef-card-country">
              {Aa(chef?.geographical_tag?.toLowerCase())}
            </span>
            <img
              src={chef?.preview}
              alt=""
              style={{
                objectFit: "cover"
              }}
            />
            <div className="chef">
              <img
                src={chef?.pic1}
                alt=""
                style={{
                  objectFit: "cover",
                  borderRadius: 20
                }}
              />
              <div>
                <p
                  style={{
                    textAlign: "left"
                  }}
                >
                  {chef?.chef ? "Chef" : "Restaurant"}{" "}
                  {Aa(chef?.firstname) + " " + Aa(chef?.lastname)}
                </p>
                <Rating
                  value={
                    chef?.review_count === 0
                      ? 0
                      : chef?.stars_count / chef?.review_count
                  }
                  readOnly
                  precision={0.5}
                  style={{
                    marginTop: -10
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChefCard;
